/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_No_OrganizationInputs */

const en_page_title_no_organization = /** @type {(inputs: Page_Title_No_OrganizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No organization`)
};

const nl_page_title_no_organization = /** @type {(inputs: Page_Title_No_OrganizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen organisatie`)
};

/**
* | output |
* | --- |
* | "No organization" |
*
* @param {Page_Title_No_OrganizationInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const page_title_no_organization = /** @type {((inputs?: Page_Title_No_OrganizationInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_No_OrganizationInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_page_title_no_organization(inputs)
	return en_page_title_no_organization(inputs)
});